/** Lifecycle statuses, wire vocabulary = the backend enum member names (R09). */
export const PROJECT_STATUSES = ["Idea", "InProgress", "Suspended", "Closed", "Archived"];
/**
 * Statuses a project can still be funded in: what a donation allocation picker and a campaign's
 * funded-projects picker offer. Closed, Suspended and Archived projects stay searchable without
 * a filter, for the callers that resolve the names of projects already linked.
 */
export const FUNDABLE_PROJECT_STATUSES = ["Idea", "InProgress"];
/** Territorial scopes ("Périmètre territorial"), wire vocabulary = the backend enum member names. */
export const TERRITORIAL_SCOPES = ["International", "National", "Regional", "Local"];
/** Milestone statuses ("Jalons"), wire vocabulary = the backend enum member names. */
export const MILESTONE_STATUSES = ["Upcoming", "InProgress", "Achieved", "Blocked"];
/** Sort columns of the project's donation list, wire vocabulary = the OPDON enum member names. */
export const PROJECT_DONATIONS_SORT_FIELDS = ["Date", "Donor", "Amount"];
